export default "__VITE_ASSET__CTulEygk__"